export default __webpack_public_path__ + "static/media/tape.f3cbea95.png";